module.exports = __webpack_public_path__ + "static/media/32.ff07cb7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/32.jpg
// module id = 207
// module chunks = 0